import { TemplatesReducerCreator } from '../types';

const updateRefetchTemplatesCounterReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state) => {
    state.refetchTemplatesCounter++;
  });
};

export default updateRefetchTemplatesCounterReducer;
